var _circle, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBttnDelete = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bttn_delete_hover",
    "data-name": "bttn_delete hover",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(40) rotate(90)",
    fill: "#e41e15",
    opacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icn_close",
    d: "M23.658,21.289,30.8,14.144a1.674,1.674,0,0,0-2.368-2.368L21.29,18.921l-7.145-7.145a1.674,1.674,0,1,0-2.368,2.368l7.145,7.145-7.145,7.145A1.674,1.674,0,0,0,14.145,30.8l7.145-7.145L28.435,30.8A1.674,1.674,0,0,0,30.8,28.434Z",
    transform: "translate(-1.288 -1.289)",
    fill: "#e41e15",
    opacity: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBttnDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bttn_delete.b9852d7a.svg";
export { ForwardRef as ReactComponent };